import React from "react";
import { useCategoryContext } from "~/assets/js/pages/Category/CategoryProvider";
import { Search } from "react-feather";
import { ForwardButton } from "~/assets/js/components/Button";
import i18next from "i18next";

const URL_REDIRECTS = {
    BOWL: "/meine-bowl/",
    SALAD: "/mein-potti/",
};

const NoProducts = () => {
    const { state } = useCategoryContext();

    const renderContent = () => {
        if (state.isMainDish || state.isSubcategory) {
            const product =
                state.isSalad || state.isSubcategory
                    ? i18next.t("category.label.noItemsFound.saladContent")
                    : state.isBowl
                    ? i18next.t("category.label.noItemsFound.bowlContent")
                    : i18next.t("category.label.noItemsFound.soupContent");

            return i18next.t("category.label.noItemsFound.subCategoryContent", {
                content: i18next.t(
                    "category.label.noItemsFound.productContent",
                    {
                        product,
                    }
                ),
            });
        }

        return i18next.t("category.label.noItemsFound.defaultContent");
    };

    const renderCTA = () => {
        if (state.isMainDish || state.isSubcategory) {
            return (
                <div className="category-products__no-products__cta">
                    <ForwardButton
                        size="XS"
                        variant="primary"
                        label={i18next.t("category.label.noItemsFound.bowlCTA")}
                        href={URL_REDIRECTS.BOWL}
                    />
                    <ForwardButton
                        size="XS"
                        variant="secondary"
                        label={i18next.t(
                            "category.label.noItemsFound.saladCTA"
                        )}
                        href={URL_REDIRECTS.SALAD}
                    />
                </div>
            );
        }

        return null;
    };

    return (
        <div className="category-products__no-products">
            <Search />
            <p className="category-products__no-products__heading">
                {i18next.t("category.label.noItemsFound.title")}
            </p>
            <p className="category-products__no-products__text">
                {renderContent()}
            </p>
            {renderCTA()}
        </div>
    );
};

export default NoProducts;
